import Build from '../core/Build';
import { buildElementGradient, buildElementGradientHover } from '../components/utils/CardGradient';
import { resolveMediaUrl } from './mediaUrl';

/** Item icon URL for build cards (aligned with BuildSlot.getImage). */
const FALLBACK_ITEM_ICON = '/img/stat_re_armes.png';

/**
 * Same element coloring as search ItemCard: radial gradient from blended stats.
 * Uses Build.getStats() so items + scrolls + exos + sets are included.
 */
export function getBuildCardGradients(buildData) {
    try {
        const b = new Build(buildData || {});
        const stats = b.getStats();
        return {
            gradient: buildElementGradient(stats, true),
            gradientHover: buildElementGradientHover(stats, true)
        };
    } catch {
        return {
            gradient: buildElementGradient({}, true),
            gradientHover: buildElementGradientHover({}, true)
        };
    }
}

export function itemIconSrc(item) {
    return item?.icon ? resolveMediaUrl(item.icon) : FALLBACK_ITEM_ICON;
}

export function itemDisplayName(item, lang) {
    if (!item?.name) return '';
    if (typeof item.name === 'object') {
        return item.name[lang] || item.name.fr || item.name.en || '';
    }
    return String(item.name);
}
